// System
import { useSnackbar } from 'notistack';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Stack, Typography, Box, IconButton } from '@mui/material';

// Styles
import Styles from './SetupProviderHeader.module.scss';
import { useProviderDrawer } from '@Modal/hooks/providers/useProviderDrawer';

export const SetupProviderHeader: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { selectedProviderData } = useProviderDrawer();

  const handleCopy = () => {
    if (selectedProviderData.id) {
      navigator.clipboard.writeText(selectedProviderData.id).then(() => {
        enqueueSnackbar('Provider ID copied', {
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      });
    }
  };

  return (
    <Stack className={Styles.SetupProviderHeader}>
      <Box className={Styles.QrCode}>
        <Typography variant="h6">{selectedProviderData.id}</Typography>
      </Box>
      <IconButton onClick={handleCopy}>
        <ContentCopyIcon />
      </IconButton>
      <strong>RGS:{selectedProviderData?.rgsId}</strong>
    </Stack>
  );
};
